import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/salary/list", params, successCallback, failCallback, exceptionCallback);
	},toAdd: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/salary/toAddAll", params, successCallback, failCallback, exceptionCallback);
	},toPay: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/salary/toPay", params, successCallback, failCallback, exceptionCallback);
	},addSb: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/oa/salary/addSb", params, successCallback, failCallback, exceptionCallback);
	},rmSb: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/oa/salary/rmSb", params, successCallback, failCallback, exceptionCallback);
	},sp: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/oa/salary/sp", params, successCallback, failCallback, exceptionCallback);
	},rst: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/oa/salary/rstsp", params, successCallback, failCallback, exceptionCallback);
	},save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/oa/salary/save", params, successCallback, failCallback, exceptionCallback);
	},toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/salary/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/oa/salary/update", params, successCallback, failCallback, exceptionCallback);
	},remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/oa/salary/remove", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
